module.exports = __webpack_public_path__ + "static/media/testmusic.575a58d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testmusic.mp3
// module id = yDJc
// module chunks = 1